import styles from "./Plan.module.scss";
import { useEffect, useState } from "react";

export default function Plan({ chosenDate }) {
  const [date, setDate] = useState(null);
  useEffect(() => {
    if (chosenDate !== null) {
      let month =
        chosenDate.getMonth() + 1 < 10
          ? `0${chosenDate.getMonth() + 1}`
          : chosenDate.getMonth() + 1;
      let day =
        chosenDate.getDate() < 10
          ? `0${chosenDate.getDate()}`
          : chosenDate.getDate();
      let newDate = `${day}.${month}.${chosenDate.getFullYear()}r.`;
      setDate(newDate);
    }
  }, [chosenDate]);
  return (
    <>
      <div className={styles.header}>Plan dnia</div>
      <div className={styles.dataWrapper}>
        <span style={{ fontWeight: "500" }}>{date}</span>
        Brak planów tego dnia
      </div>
    </>
  );
}
